import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "marketing-email-image-preview" */'./MarketingEmailImagePreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('marketing-email-image-preview')),
  LoadingComponent: () => null
});